import { recoverUserReplyTemplateThunk } from './recoverUserReplyTemplateThunk';
import { trackReplyTemplateDeleteSuccess } from '../../containers/ReplyTemplateModalContainer/tracking';
import { currentChatOpponentIdSelector, currentOpenChatIDSelector } from '../../selectors';
import { deleteUserReplyTemplatePublic } from '../../services';
import { showAlert } from '../../slices/alertSlice';
import { createAppAsyncThunk } from '../../store/createAppAsyncThunk';
import { EAlert } from '../../types/alert';

import type { IDeleteUserReplyTemplateRequest } from '../../types/replyTemplates';

export const deleteUserReplyTemplateThunk = createAppAsyncThunk<
  number,
  IDeleteUserReplyTemplateRequest,
  { rejectValue: string }
>('chats/deleteUserReplyTemplateThunk', async (parameters: IDeleteUserReplyTemplateRequest, _thunkApi) => {
  const { fulfillWithValue, rejectWithValue, extra: context, dispatch, getState } = _thunkApi;

  const state = getState();
  const template = state.replyTemplates.data.replyTemplates.find(template => template.id === parameters.id);

  try {
    await deleteUserReplyTemplatePublic(context, parameters);

    if (template) {
      dispatch(
        showAlert({
          message: 'Шаблон удалён',
          type: EAlert.Info,
          button: {
            text: 'Восстановить',
            onClick: () =>
              dispatch(
                recoverUserReplyTemplateThunk({
                  createdAt: template.createdAt,
                  text: template.text,
                  name: template.name,
                }),
              ),
          },
        }),
      );
    }
    const opponentId = currentChatOpponentIdSelector(state);
    const chatId = currentOpenChatIDSelector(state);
    trackReplyTemplateDeleteSuccess({ chatId, opponentId, replyTemplateId: parameters.id });

    return fulfillWithValue(parameters.id);
  } catch (e) {
    dispatch(showAlert({ message: 'Не удалось удалить шаблон' }));

    return rejectWithValue(e instanceof Error ? e.message : String(e));
  }
});
